import SurgeryIndication from "@/views/surgery_indications/surgery_indication.vue";
import SurgeryIndications from "@/views/surgery_indications/index.vue";

export default [
  {
    path: "indicacao-cirurgica",
    name: "Indicação Cirurgica",
    component: SurgeryIndications,
  },
  {
    path: "indicacao-cirurgica/nova",
    name: "Nova solicitação de cirurgia",
    component: SurgeryIndication,
  },
  {
    path: "indicacao-cirurgica/:surgery_indication_id",
    name: "Editar Indicação Cirurgica",
    props: true,
    component: SurgeryIndication,
  },
];
